// extracted by mini-css-extract-plugin
module.exports = {"section":"resources-module--section--U6A16","container":"resources-module--container--2WP2u"};